// import { Link } from 'ui-kit/actions/link/Link'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import VendorLockImageMob from './visual-mob.svg'
import VendorLockImageDesk from './visual-desk.svg'
import clsx from 'clsx'
import classes from './VendorLock.module.scss'

export const VendorLock = ({ className }: { className?: string }) => {
  return (
    <div className={clsx(classes.wrapper, className)}>
      <div className={classes.content}>
        <div>
          <Heading as={'h2'} size={'md'} center className={classes.title}>
            No vendor lock-in
          </Heading>
          <div className={classes.description}>
            <Text size={'lg'} balance center className={classes.subtitle}>
              Everything you build with us is highly transparent and portable.
              You have full access to your integration logic, connectors,
              customer configurations and credentials.
            </Text>
            <Text size={'lg'} balance center className={classes.subtitle}>
              If you decide to move part or all of your integrations elsewhere -
              you can do it.
            </Text>
          </div>
        </div>
        {/* <Link
          className={classes.button}
          type='secondary'
          href='#'
        >
          Learn More
        </Link> */}
      </div>
      <div className={classes.visual}>
        <Picture
          className={classes.image}
          mobSvg={VendorLockImageMob.src}
          deskSvg={VendorLockImageDesk.src}
          width={486}
          height={269}
          alt='No vendor lock-in'
          lazyLoad
        />
      </div>
    </div>
  )
}
